import finnishHostedContentPathTranslations from '../translations/hostedContent.fi.paths.json';

const hostedContentPathTranslations = {
  fi: finnishHostedContentPathTranslations,
};

export const assetNameFromPath = assetPath => {
  const normalized = `${assetPath || ''}`.replace(/^\//, '');
  const pageMatch = normalized.match(/^content\/pages\/(.+)\.json$/);
  if (pageMatch) {
    return pageMatch[1];
  }

  const contentMatch = normalized.match(/^content\/(.+)\.json$/);
  if (contentMatch) {
    return contentMatch[1];
  }

  return normalized.replace(/\.json$/, '');
};

const buildPath = segments =>
  segments.reduce((path, segment) => {
    if (typeof segment === 'number') {
      return `${path}[${segment}]`;
    }
    return path ? `${path}.${segment}` : segment;
  }, '');

export const getHostedContentPathTranslations = language =>
  hostedContentPathTranslations[language] || {};

export const localizePageAsset = (
  pageAsset,
  translations = {},
  assetName = null,
  pathSegments = []
) => {
  if (Array.isArray(pageAsset)) {
    return pageAsset.map((value, index) =>
      localizePageAsset(value, translations, assetName, [...pathSegments, index])
    );
  }

  if (pageAsset === null || typeof pageAsset !== 'object') {
    if (typeof pageAsset !== 'string') {
      return pageAsset;
    }

    const path = buildPath(pathSegments);
    const fullKey = assetName && path ? `${assetName}.${path}` : null;
    if (fullKey && Object.prototype.hasOwnProperty.call(translations, fullKey)) {
      return translations[fullKey];
    }

    return pageAsset;
  }

  return Object.fromEntries(
    Object.entries(pageAsset).map(([key, value]) => [
      key,
      localizePageAsset(value, translations, assetName, [...pathSegments, key]),
    ])
  );
};

export const localizeHostedContent = (content, language, assetName) =>
  localizePageAsset(content, getHostedContentPathTranslations(language), assetName);
